export enum EBannerType {
  MortgageBroker,
  SubsidisedMortgage,
  CianDobro,
  DailyRent,
  CPD1000,
}
